import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
export const autofill = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autofill.url(options),
    method: 'post',
})

autofill.definition = {
    methods: ["post"],
    url: '/projects/autofill',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofill.url = (options?: RouteQueryOptions) => {
    return autofill.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofill.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autofill.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
const autofillForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autofill.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofillForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autofill.url(options),
    method: 'post',
})

autofill.form = autofillForm

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
export const searchEquations = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchEquations.url(args, options),
    method: 'get',
})

searchEquations.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/search-equations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return searchEquations.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchEquations.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
const searchEquationsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquationsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquationsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchEquations.form = searchEquationsForm

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
export const stats = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

stats.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return stats.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: stats.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
const statsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
statsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
statsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

stats.form = statsForm

const ProjectStatsController = { autofill, searchEquations, stats }

export default ProjectStatsController